import { JSApi, Log } from '..';
export var NotifyStatus;
(function (NotifyStatus) {
    NotifyStatus[NotifyStatus["downloadStart"] = 0] = "downloadStart";
    NotifyStatus[NotifyStatus["downloadEnd"] = 1] = "downloadEnd";
    NotifyStatus[NotifyStatus["downloadCancel"] = 2] = "downloadCancel";
    NotifyStatus[NotifyStatus["uploadStart"] = 3] = "uploadStart";
    NotifyStatus[NotifyStatus["uploadEnd"] = 4] = "uploadEnd";
})(NotifyStatus || (NotifyStatus = {}));
var BridgeHelper = /** @class */ (function () {
    function BridgeHelper() {
    }
    BridgeHelper.notifyNative = function (params) {
        JSApi.invokeNative('docx', 'notifyNative', params, function () {
            Log.debug(BridgeHelper.TAG, 'notifyNative ', params);
        });
    };
    BridgeHelper.callClient = function (method, data) {
        JSApi.invokeNative('docx', 'callClient', {
            method: method,
            data: data,
        }, function () {
            Log.debug(BridgeHelper.TAG, "callClient method:" + method + " data:" + data);
        });
    };
    BridgeHelper.TAG = 'BridgeHelper';
    return BridgeHelper;
}());
export { BridgeHelper };
//# sourceMappingURL=BridgeHelper.js.map